import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'
import { portalMessage } from '@/components/base'
import { resolvePortalBrowserUrl } from '@/utils/external'

const baseURL = import.meta.env.VITE_API_BASE_URL ?? ''
if (baseURL) {
  axios.defaults.baseURL = baseURL
}

autosetup()

export function autosetup() {
  axios.defaults.withCredentials = shouldSendCredentials(baseURL)
  axios.interceptors.request.use(
    (config) => {
      const auth = useAuthStore()
      config.headers = config.headers ?? {}

      if (auth.token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${auth.token}`
      }

      if (auth.tenantSlug && !config.headers['X-Smart-Tenant']) {
        config.headers['X-Smart-Tenant'] = auth.tenantSlug
      }

      return config
    },
    (error) => Promise.reject(error),
  )

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const auth = useAuthStore()
      const status = error.response?.status

      if (status === 401) {
        const currentRoute = router.currentRoute.value
        const tenantParam = typeof currentRoute.params.tenant === 'string' ? currentRoute.params.tenant : undefined
        const tenant = auth.tenantSlug || tenantParam || ''
        const redirect = currentRoute.fullPath
        auth.logout()
        router.push({
          name: 'login',
          query: {
            redirect,
            tenant,
          },
        })
        portalMessage.warning('登录状态已失效，请重新登录')
      } else if (status === 429) {
        portalMessage.error('请求过于频繁，请稍后再试')
      } else if (status && status >= 500) {
        portalMessage.error('服务器繁忙，请稍后再试')
      }

      return Promise.reject(error)
    },
  )
}

function shouldSendCredentials(baseURL: string): boolean {
  if (!baseURL || typeof window === 'undefined') {
    return true
  }

  try {
    const target = resolvePortalBrowserUrl(baseURL, { protocols: ['http:', 'https:'] })
    const current = resolvePortalBrowserUrl('/', { protocols: ['http:', 'https:'] })
    if (!target || !current) return false
    return new URL(target).origin === new URL(current).origin
  } catch {
    return false
  }
}

